import { COLOR_INPUT_WIDTH_DESKTOP, COLOR_INPUT_WIDTH_MOBILE } from './ColorSelector.constants'
import { CodeConfigurationField } from '@dtx-company/inter-app/src/types/flowcode'
import { ColorInput } from './ColorInput'
import { FC } from 'react'
import { GeneratorSectionFieldset } from '../../subcomponents/GeneratorSectionFieldSet/GeneratorSectionFieldSet'
import { LOGGED_OUT_GENERATOR_COLORS } from '../../../../Homepage/SimplifiedDesktop/constants'
import { Stack } from '@dtx-company/design-system/src'
import { selectColor } from '@app/code/src/machines/locg/locgSelectors'
import { useGlobalServices } from '@app/common/src/hooks/useGlobalServices'
import { useSelector } from '@xstate/react'
import useTranslation from 'next-translate/useTranslation'

export const ColorSelector: FC = () => {
  const { locgService } = useGlobalServices()
  const selectedColor = useSelector(locgService, selectColor)
  const { t } = useTranslation('logged-out-generator')

  return (
    <GeneratorSectionFieldset
      heading={t('LoggedOutGenerator.ColorSelector.heading')}
      description={t('LoggedOutGenerator.ColorSelector.description')}
    >
      <Stack
        component="ul"
        sx={theme => ({
          listStyleType: 'none',
          padding: 0,
          mt: 4,
          mb: 0,
          display: 'grid',
          gridTemplateColumns: {
            xs: `repeat(auto-fill, minmax(${COLOR_INPUT_WIDTH_MOBILE}, 1fr))`,
            md: `repeat(auto-fill, minmax(${COLOR_INPUT_WIDTH_DESKTOP}, 1fr))`
          },
          gap: theme.spacing(4)
        })}
      >
        {LOGGED_OUT_GENERATOR_COLORS.map(color => {
          return (
            <ColorInput
              key={color.id}
              color={color}
              selected={selectedColor?.id === color.id}
              handleChange={() =>
                locgService.send({
                  type: 'CHANGE',
                  key: CodeConfigurationField.COLOR,
                  value: color
                })
              }
            />
          )
        })}
      </Stack>
    </GeneratorSectionFieldset>
  )
}
